/* By Siu */

document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia("(min-width: 600px)").matches) {
    let filtersExpanded = false;
    let lastFilterCount = 0;
  
    function updateFilterBlocks() {
      const filterContainer = document.querySelector('.gf-filter-contents-inner');
      if (!filterContainer) return;
  
      const allFilterBlocks = Array.from(filterContainer.querySelectorAll('.gf-option-block'));
  
      if (allFilterBlocks.length === 0) return;
  
      // Only proceed if the count has changed or button is missing
      const showMoreBtnExists = !!filterContainer.querySelector('.show-more-button');
      if (allFilterBlocks.length === lastFilterCount && showMoreBtnExists) return;
  
      lastFilterCount = allFilterBlocks.length;
  
      // Remove old button if it exists
      const existingBtn = filterContainer.querySelector('.show-more-button');
      if (existingBtn) existingBtn.remove();
  
      if (allFilterBlocks.length <= 5) {
        allFilterBlocks.forEach(block => (block.style.display = 'block'));
        return;
      }
  
      // Apply visibility logic
      allFilterBlocks.forEach((block, index) => {
        if (index < 5 || filtersExpanded) {
          block.style.display = 'block';
        } else {
          block.style.display = 'none';
        }
      });
  
      // Create and insert the button
      const showMoreButton = document.createElement('button');
      showMoreButton.className = 'show-more-button gf-option-block';
      showMoreButton.textContent = filtersExpanded ? 'LESS -' : 'MORE +';
      allFilterBlocks[4].insertAdjacentElement('afterend', showMoreButton);
  
      showMoreButton.addEventListener('click', () => {
        filtersExpanded = !filtersExpanded;
        // Directly update visibility without waiting for next interval
        allFilterBlocks.forEach((block, index) => {
          if (index < 5 || filtersExpanded) {
            block.style.display = 'block';
          } else {
            block.style.display = 'none';
          }
        });
        showMoreButton.textContent = filtersExpanded ? 'LESS -' : 'MORE +';
      });
    }
  
    // Still use interval (because Smart Filter doesn't expose events), but now it's safe
    setInterval(updateFilterBlocks, 500);
  }
});

document.addEventListener('click', function (event) {
  // If the click is inside a filter dropdown, do nothing
  if (event.target.closest('.gf-option-block')) return;
  if (event.target.closest('.show-more-button')) return;

  // Collapse all filter dropdowns
  document.querySelectorAll('.gf-option-block').forEach(block => {
    block.classList.add('is-collapsed');
  });
});


/*
// First version of MORE button of filters

document.addEventListener('DOMContentLoaded', function() {

    // Add the .sort-custom div
    function moveSortingMenu() {
      var label = document.querySelector('.sort-by-toggle');
      if (label) {
        const textNode = label.childNodes[0];
        if(textNode.length > 0) {
        
          // Define selectors for both collection and search result containers
          var selectors = [
              '.cc-collection-products > .container',
              '.cc-main-search > .container'
          ];
          
          selectors.forEach(function(containerSelector) {
              var container = document.querySelector(containerSelector);
              if (container) {
                  var target = container.querySelector('.main-products-grid');
                  if (target && !container.querySelector('.sort-custom')) {
                      var divElement = document.createElement('div');
                      divElement.className = 'sort-custom';
                      target.parentNode.insertBefore(divElement, target);
                  }
              }
          });
  
          // Move the .sort-by div inside the .sort-custom div
          var sortByElement = document.querySelector('.sort-by');
          var sortCustomElement = document.querySelector('.sort-custom');
          if (sortByElement && sortCustomElement) {
              sortCustomElement.appendChild(sortByElement);
              label.removeChild(textNode);
          }
          clearInterval(timerMoveSortingMenu);
        }
      }
    }

    // Function to handle the addition of the "SHOW MORE" button
    function addShowMoreButton(filterContents) {
        if (filterContents) {
            //console.log(filterContents);
            // Check if the button already exists to avoid duplicates
            if (filterContents.querySelector('.show-more-button')) return;

            // Create the "SHOW MORE" button
            const showMoreButton = document.createElement('button');
            showMoreButton.className = 'show-more-button gf-option-block';
            showMoreButton.textContent = 'MORE +';

            // Add the button after the seventh filter box
            const seventhFilterBox = filterContents.querySelector('.gf-option-block:nth-child(7)');
            if (seventhFilterBox) {
                const fifthFilterBox = filterContents.querySelector('.gf-option-block:nth-child(5)');
                if (fifthFilterBox) {
                    fifthFilterBox.insertAdjacentElement('afterend', showMoreButton);
                }
                
                // Add click event listener to the "SHOW MORE" button
                showMoreButton.addEventListener('click', function() {
                    const hiddenFilters = filterContents.querySelectorAll('.gf-option-block:nth-child(n+7)');
                    if (showMoreButton.textContent === 'MORE +') {
                        hiddenFilters.forEach(function(filter) {
                            filter.style.display = 'block';
                        });
                        showMoreButton.textContent = 'LESS -';
                    } else {
                        hiddenFilters.forEach(function(filter) {
                            filter.style.display = 'none';
                        });
                        showMoreButton.textContent = 'MORE +';
                    }
                    const optionBlocks = document.querySelectorAll('.gf-option-block');
                    optionBlocks.forEach(block => {
                        block.classList.add('is-collapsed');
                    });
                });

                // Initially hide filters beyond the sixth one
                const hiddenFilters = filterContents.querySelectorAll('.gf-option-block:nth-child(n+7)');
                hiddenFilters.forEach(function(filter) {
                    filter.style.display = 'none';
                });
            }

        }      
        
    }
  
    // Function to ensure all elements are loaded  
    function ensureElementsLoaded() {
          // Select all elements with the class 'gf-filter-contents'
          const filterContentsList = document.querySelectorAll('.gf-filter-contents-inner');          
          if (filterContentsList.length > 0) {
              filterContentsList.forEach((filterContents, index) => {
                  addShowMoreButton(filterContents);
              });
          }
    }
  
    function cancelTimers() {
      clearInterval(timerShowMore);
    }

  
    var timerShowMore;
    var timerMoveSortingMenu;
  
    // Observe the document body for changes
    if (window.innerWidth >= 768) {
      // Initial attempt to add the "SHOW MORE" button
      timerShowMore = setInterval(ensureElementsLoaded, 300);
      timerMoveSortingMenu = setInterval(moveSortingMenu, 100);
      //setTimeout(cancelTimers, 2500);
    }
});
*/